import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const DATE_FORMAT = 'MMM D, YYYY'

/**
 * Format a competition's start/end into a single display range.
 *
 * Parsed as UTC: the API returns midnight-UTC dates, so local parsing would
 * shift them a day back for anyone west of UTC.
 *
 * - both dates  → "Jul 24, 2026 - Jul 31, 2026"
 * - same day    → "Jul 24, 2026"
 * - one only    → that date alone
 * - neither     → undefined (caller hides the row)
 */
export const formatScheduleDateRange = (
  startsAt?: string | null,
  endsAt?: string | null
): string | undefined => {
  const start = startsAt ? dayjs.utc(startsAt) : undefined
  const end = endsAt ? dayjs.utc(endsAt) : undefined

  const validStart = start?.isValid() ? start : undefined
  const validEnd = end?.isValid() ? end : undefined

  if (!validStart && !validEnd) {
    return undefined
  }
  if (validStart && !validEnd) {
    return validStart.format(DATE_FORMAT)
  }
  if (!validStart && validEnd) {
    return validEnd.format(DATE_FORMAT)
  }
  const startText = (validStart as dayjs.Dayjs).format(DATE_FORMAT)
  const endText = (validEnd as dayjs.Dayjs).format(DATE_FORMAT)

  return startText === endText ? startText : `${startText} - ${endText}`
}
